import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import _ from "lodash";
import moment from "moment";
import React, { memo, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../../master/style";
  
  const WhCashClose = () => {
    const roleId = localStorage.getItem("role_id")
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const classes = useStyle();
    const amtRef = useRef(null);
    const [salesMan, setSalesMan] = useState([]); // salesman id
    const [sideBardata, setSideBarData] = useState([]);
    const outId = localStorage.getItem("outlet_id");
    const wareHouseId = localStorage.getItem('userId')
    const[balance , setBalance] = useState(0)
    const [open , setOpen] = useState(false)
    const [newDayBalance , setNewDayBalance] = useState("")
    const [poDetails, setPoDetails] = useState({
      Date: moment().format(),
      salesManId: null,
    });
    const [dateLimit, setDateLimit] = useState({
      fromDate : moment().format(),
    })
    function handleChangeDate(e, name) {
      setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
    }
    const [companyData , setCompanyData] = useState([])
    const [salesID, setSalesID] = useState(null)
    const [postData, setPostData] = useState({
      date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      total: 0,
      warehouse_id: wareHouseId,
      closing_cash_wh_details: [],
  
    });
  console.log(sideBardata)
    const initialValue = [
      { note: 2000, nos: "", amt: "" },
      { note: 500, nos: "", amt: "" },
      { note: 200, nos: "", amt: "" },
      { note: 100, nos: "", amt: "" },
      { note: 50, nos: "", amt: "" },
      { note: 20, nos: "", amt: "" },
      { note: 10, nos: "", amt: "" },
      { note: 5, nos: "", amt: "" },
      { note: 2, nos: "", amt: "" },
      { note: 1, nos: "", amt: "" },
    ];
    const [data, setData] = useState(initialValue);
    const [active, setActive] = useState(0);
  
    function handleChange(e, idx) {
      const value = e.target.value.replace(/[^0-9]/g, "").trim();
      const arr = [...data];
      setData([])
      console.log(value, arr[idx])
        arr[idx].nos = value;
        arr[idx].amt = arr[idx].note *( value==="" ? 0 : parseFloat(value));
      console.log(arr[idx].amt)
      arr.forEach((item) => {
        if (!item.nos.trim() && item.amt !== "0.00") {
          item.amt = "";
        }
      });
  
      setData(arr);
    }
  
    function handleKey(e) {
      if (e.key === "Enter" && data.length > active) {
        setActive((prev) => prev + 1);
        amtRef.current.focus();
      }
    }
    
    let totalAmt = 0;
  
    data.forEach((item) => {
      if (item.amt !== "") {
        totalAmt += parseFloat(item.amt);
      } else {
        totalAmt += 0;
      }
    });
    const textData = {
      tot:parseFloat(totalAmt).toFixed(2),
      date:moment().format("DD-MM-YYYY"),
      
    }
    const tableData = _.map(postData.closing_cash_details, ((val , idx)=>({ 
      sno:++idx,
     denomination:val.denomination,
     count:val.count,
     total:val.total
    })))
    // useEffect(() => {
    //   axios.get(`/v1/outlet/info/${outId}`)
    //   .then((res) => {console.log(res.data);setCompanyData(res.data)})
    //   .catch((err) => {console.log(err)})
    //     },[])
        const onCheck =() => {
       
            setOpen(true)
          
        }
        console.log(postData)
    const onSave = () => {
      // if (poDetails.salesManId === null) {
      //   dispatch(setSnackbar(true, "error", "Please Select Salesman"));
      // } 
      // // else if(balance === "") {
      // //   dispatch(setSnackbar(true, "error", "Please Enter The Deposited Amount"));
      // // } 
      // else {
        console.log("post method",  postData);
        axios
        .post(`/v1/closing_cash_warehouse_master`, postData)
        .then((res) => {
          console.log(res)
          setData(initialValue)
          setOpen(false)
          dispatch(setSnackbar(true, 'success', "Cash Closed successfully"))
          // setTimeout(() => {
          //   window.location.reload();
          // },[1000])
  
        //   dispatch(setThermalData({
        //     tableData : tableData,
        //     TotalData : textData,
        //     companyInfo:companyData
        //   }))      
        //   dispatch(onPressButton())
        //   const name = `CashBill`
        //   navigate(`/cashClose/${name}`) 
  
  
        })
        .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
          setOpen(false)
        });
      // }
      // const Date = moment().format("DD-MMM-YYYY");
      // const time = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
      // const cashClosedata = {
      //   e_date: Date,
      //   e_time: time,
      //   type: "s",
      //   N2000: parseInt(data[0].nos) || 0,
      //   N500: parseInt(data[1].nos) || 0,
      //   N200: parseInt(data[2].nos) || 0,
      //   N100: parseInt(data[3].nos) || 0,
      //   N50: parseInt(data[4].nos) || 0,
      //   N20: parseInt(data[5].nos) || 0,
      //   N10: parseInt(data[6].nos) || 0,
      //   N5: parseInt(data[7].nos) || 0,
      //   N2: parseInt(data[8].nos) || 0,
      //   N1: parseInt(data[9].nos) || 0,
      // //   coin: data[0].coin || 0,
      // };
      // console.log(cashClosedata);
      // axios
      //   .post(`Denomination`, cashClosedata)
      //   .then((res) => {
      //     setData(initialValue)
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     // dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
      //   });
    };
  
    const onBalanceChange = (e) => {
      const inputValue = e.target.value.replace(/[^0-9]/g, '');
      setBalance(inputValue)
      console.log(inputValue)
      if(inputValue===""){
        setNewDayBalance("")
      }
     else if( totalAmt > inputValue){
        setNewDayBalance(totalAmt-inputValue);
      }else {
        setNewDayBalance(inputValue - totalAmt)
      }
    };
    const newBalanceChange = (e) => {
      const newB = e.target.value.replace(/[^0-9]/g, '');
          setNewDayBalance(newB)
    }
  
    useEffect(()=>{
      const postingData = data
      .filter(item => item.nos !== "" && item.amt !== "")
      .map(item => ({
        denomination: item.note,
        count: parseInt(item.nos),
        total: parseFloat(item.amt),
        date: moment().format("YYYY-MM-DD"),
        warehouse_id: wareHouseId,
      }));
     
      console.log(postingData.length)
      if(postingData.length == 0){
        setBalance(0)
        setNewDayBalance("0")
      }
      setPostData(prev=>({...prev,date: moment(dateLimit.fromDate).format("YYYY-MM-DD"), closing_cash_wh_details: postingData ,total:parseFloat(totalAmt).toFixed(2) ,
       
        amount_be_deposited:balance,
        next_day_balance:newDayBalance
      }))
    },[data, salesID,sideBardata,balance , newDayBalance,dateLimit])
   
    return (
      <Grid className="bg-white relative ">
        <Helmet><title>WareHouse cash close</title></Helmet>
        <Grid
          className="flex justify-between items-center px-2"
          sx={{ marginBlockEnd: 1 }}
        >
          <div>
            <Typography className={classes.titleCashClose}>Cash Close</Typography>
          </div>
      
        </Grid>
        <Grid container sx={{marginTop:"30px"}}>
            <Grid md={2}>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
                <TableContainer
                className={classes.tblRoot}
                sx={{ maxWidth: "70%", margin: "0 auto" }}
                >
                <Table>
                    <TableHead className={classes.tblHeader}>
                    <TableRow>
                        <TableCell
                        sx={{
                            borderRight: "0.5px solid  #ccc",
                            textAlign: "center",
                        }}
                        >
                        Notes
                        </TableCell>
                        <TableCell
                        sx={{
                            borderRight: "0.5px solid  #ccc",
                            textAlign: "center",
                        }}
                        >
                        Nos
                        </TableCell>
                        <TableCell>Amount</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {_.map(data, (val, idx) => (
                        <TableRow key={val.note} className={classes.tablrow} onClick={() => setActive(idx)}>
                        <TableCell sx={{ borderRight: `1px solid #ccc` , }}className={classes.tblHeadCell}>{val.note}</TableCell>
                        <TableCell sx={{ borderRight: `1px solid #ccc` ,}}>
                            <TextField
                            size="small"
                            autoComplete="off"
                            value={val.nos}
                            onKeyPress={(e) => handleKey(e, idx)}
                            inputRef={active === idx ? amtRef : null}
                            InputProps={{
                                style: {
                                maxHeight: "10px",
                                outline: "none",
                                fontSize: 14,
                                },
                            }}
                            inputProps={{ style: { textAlign: "right" } }}
                            className={classes.tableInput}
                            onChange={(e) => handleChange(e, idx)}
                            />
                        </TableCell>
    
                        <TableCell align="right" padding="checkbox"sx={{ minWidth: 130, fontWeight: 700, padding: 0,height:"25px" }}>
                            <Typography fontWeight={700} textAlign="right">{val.amt !== "" && parseFloat(val.amt).toFixed(2)}</Typography>
                        </TableCell>
                        </TableRow>
                    ))}
                    <TableRow className={classes.tablrow} sx={{padding:0}}>
                        <TableCell sx={{ borderRight: `1px solid #ccc` }} />
                        <TableCell />
                    </TableRow>
                    <TableRow>
                        <TableCell sx={{padding:"7px",height:"15px"}} colSpan={2}>Total</TableCell>
                        <TableCell
                        sx={{
                            borderLeft: `1px solid #ccc`,
                            textAlign: "right",
                            fontWeight: 700,
                            padding:"7px",height:"15px"
                        }}
                        >
                        {parseFloat(totalAmt).toFixed(2)}
                        </TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell colSpan={2} sx={{padding:"7px",height:"15px"}}>Amount To Be Deposited</TableCell>
                        <TableCell sx={{
                            borderLeft: `1px solid #ccc`,
                            textAlign: "right",
                            fontWeight: 700,
                            padding:"7px",height:"15px"
                        }}><TextField size="small" autoComplete="off"  disabled={totalAmt === 0}  inputProps={{
                            style: {
                            textAlign: "right",
                            fontWeight: "bold",
                            padding:"7px",height:"15px"
                            },
                        }} 
                        value={balance}
                        onChange={onBalanceChange}
                        />
                        </TableCell>
                    </TableRow>
                    <TableRow > 
                        <TableCell sx={{padding:"7px",height:"15px"}} colSpan={2}>Next Day Balance</TableCell> 
                        <TableCell sx={{
                            borderLeft: `1px solid #ccc`,
                            textAlign: "right",
                            fontWeight: 700,
                            padding:"7px",height:"15px"
                        }}>
                            <TextField  size="small"  autoComplete="off"  inputProps={{
                            style: {
                            textAlign: "right",
                            fontWeight: "bold",
                            padding:"7px",height:"15px"
                            },
                        }} 
                        disabled={balance === ""}
                        value={newDayBalance }
                        onChange={newBalanceChange}
    
                        />
                        
                        </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
                <Grid className="my-2 flex justify-center">
                <Button  onClick={onCheck}  variant="contained">
                    Submit
                </Button>
                </Grid>
            </Grid>
            <Grid md={2}>
            </Grid>
        </Grid>
        <Dialog open={open}>
        <DialogTitle>Cash CLose</DialogTitle>
        <DialogContent>
          <Typography>Are you sure want to close the cash</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setOpen(false)}>No</Button>
          <Button variant="contained" onClick={onSave}>Yes</Button>
        </DialogActions>
        </Dialog>
      </Grid>
    );
  };
  
  export default memo(WhCashClose);
  